<template>
  <Modal :show="show" :onClose="onClose" class="modal-window" position="center-right">
    <div class="custom-container">
      <div class="heading">
          <h1 class="page-title">{{ pageTitle }}</h1>
          <span class="value title">{{ $t('call_confirmation.access_code') }}</span>
          <span class="value event-id-value">{{formattedEventId}}</span>
          <span class="value title">{{ $t('call_confirmation.your_PIN') }}</span>
          <span class="value">{{formattedPin}}</span>
      </div>
      <div class="description">
        <table class="custom-table">
          <thead>
            <tr>
              <th>{{ $t('global_numbers.calling_from') }}</th>
              <th>{{ $t('global_numbers.number') }}</th>
            </tr>
          </thead>
          <tbody v-for="(number, index) in numbers" :key="index">
            <tr v-if="number.AutomatedTollPhoneNumbers.length">
              <td>{{number.Country.Name}}</td>
              <td class="numbers">
                <tr v-for="(tollNum, idx) in number.AutomatedTollPhoneNumbers" :key="idx"> 
                  {{telFormatter(tollNum, number.Country.Code) }}
                </tr> 
              </td>
            </tr>
            <tr v-if="number.AutomatedPhoneNumbers.length">
              <td>{{number.Country.Name}} Toll-Free</td>
              <td class="numbers">
                <tr v-for="(tollfreeNum, idx) in number.AutomatedPhoneNumbers" :key="idx"> 
                  {{telFormatter(tollfreeNum, number.Country.Code) }}
                </tr> 
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
</template>


<script setup>
import { computed } from 'vue';
import Modal from "@/components/ui/Modal";
import TelFormatter from "@/service/telFormatter";
import Constants from "@/utils/constants";

// Define component name
defineOptions({
  name: 'modal-window'
});

// Props
const props = defineProps({
  show: { type: Boolean, required: true },
  onClose: { type: Function, default: () => {} },
  numbers: { type: Array, default: () => [] },
  eventId: { type: String },
  pin: { type: String },
  pageTitle: { type: String, default: "" },
  bridgeType: { type: String, default: ""}
});

// Methods
const telFormatter = (tel, countryCode, hideTelephoneCode) => {
  return TelFormatter(tel, countryCode, hideTelephoneCode);
};

// Computed properties
const formattedEventId = computed(() => {
  if (props.bridgeType === Constants.BridgeTypes.Compunetix) {
    return props.eventId + '#';
  }
  return props.eventId;
});

const formattedPin = computed(() => {
  if (props.bridgeType === Constants.BridgeTypes.Compunetix) {
    return props.pin + '#';
  }
  return props.pin;
});
</script>

<style lang="stylus" scoped>
  .event-id-value {
    margin-right: 30px;
    @media screen and (max-width: 1070px) {
      margin-right: 15px;
    }
  }
  .call-login-details {
    @media screen and (max-width: 1070px) {
      flex-direction: column;
    }
  }
  .numbers {
    tr {
      border-bottom: none;
    }
    tr:not(:first-child) {
    display: block;
    margin-top: 5px;
    }
  }
  .modal-window {
    padding: 0 8.33335%;
    @media screen and (max-width: 1070px) {
      padding: 0 15px;
    }
    @media screen and (max-width: 1204px) {
      justify-content center;
    }
    & :deep(.modal-content) {
      padding: 0 0 10px 0;
      width: calc(50% - 8.33335%);
      height: 90%;
      border none;
      @media (max-width: 1024px) {
        width 80%;
        justify-content center;
      }
      @media (max-width: 1070px) {
        width: 100%;
      }
    }
    .custom-container {
      text-align: center;
      height: 100%;
      padding: 25px;
      box-sizing: border-box;
      @media (max-width: 768px) {
        padding: 25px 10px;
      }
    }
    .heading {
      margin-bottom: 15px;
      font-weight: bolder;
      font-size: larger;
      text-align: left;
      text-align: center;
      color: #414141;
      margin-bottom: 40px;
    }
    .page-title {
      font-size: 25px;
      -webkit-text-align: center;
      max-width: 250px;
      margin: 0 auto 30px auto;
      text-align: center;
      font-family: sans-pro-bold;
    }
    .title {
      font-family: sans-pro-bold;
    }
    .value {
      font-size: 20px;
      @media (max-width: 768px) {
        font-size: 18px;
      }
    }
    .description {
      padding: 0 30px;
      height: calc(100% - 180px);
      overflow-y: auto;
      }
      .custom-table {
        width: 100%;
      text-align: left;
      line-height: 1.6;
      table-layout: fixed;
      font-size: 13px;
      th {
        color: #b7b7b7;
        line-height : 2;
        text-align: left;
        border-bottom: 1px solid #E6E6E6;
      } 
      td {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding: 10px 0;
        line-height: 1;
      }
      tr {
        border-bottom: 1px solid #E6E6E6;
      }
      tr th:last-child,td:last-child { 
        padding-left : 10%;
      }
    }
  }
</style>


